import React from "react";

export default function CardLayout({ children, onClick }) {
  return (
    <div className="col">
      <div className="dashboard-card-item" onClick={onClick}>
        {children}
      </div>
    </div>
  );
}
